<template>
  <div class="products">
    <div class="header-switch">
      <p :class="{ active: state === 1 }">
        <span @click="handleStateSwitch(1)">{{ $t("products.tab1") }}</span>
      </p>
      <p :class="{ active: state === 0 }">
        <span @click="handleStateSwitch(0)">{{ $t("products.tab2") }}</span>
      </p>
    </div>
    <div class="page-action-box">
      <div class="btns">
        <el-button
          type="primary"
          round
          plain
          size="mini"
          v-show="state === 0"
          @click="handleChangeProductsState(1)"
          >{{ $t("products.btn1") }}</el-button
        >
        <el-button
          type="primary"
          round
          plain
          size="mini"
          v-show="state === 0"
          @click="handleDeleteProducts"
          >{{ $t("products.btn3") }}</el-button
        >
        <el-button
          type="primary"
          round
          plain
          size="mini"
          v-show="state === 1"
          @click="handleChangeProductsState(0)"
          >{{ $t("products.btn2") }}</el-button
        >
        <el-button type="primary" round size="mini" @click="handleAddProduct">{{
          $t("products.btn4")
        }}</el-button>
      </div>
      <div class="pages">
        <p style="margin-right: 50px">
          {{
            $t("products.count", {
              number: count,
            })
          }}
        </p>
      </div>
    </div>
    <el-table :data="contents" ref="table">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column :label="$t('products.col1')" width="250">
        <template slot-scope="scope">
          <div class="row-product-name">
            <el-image
              :src="scope.row.imageUrl"
              fit="cover"
              class="image"
            ></el-image>
            <div class="content">
              <!-- <img v-if="scope.row.IsTB===1" src='~assets/img/shopManage/icon_label.png' class="labelimg"> -->
              <p class="title">{{ scope.row.ProductName }}</p>
              <p class="id">ID:{{ scope.row.ProductNumber }}</p>
              <p class="discount" v-if="scope.row.IsCouponProduct === 1">
                {{ $t("products.isCouponProduct") }}
              </p>
              <p class="brand" v-if="scope.row.IsBrandProduct === 1">
                {{ $t("products.isBrandProduct") }}
              </p>
              <p class="att" v-if="scope.row.IsAttestationProduct === 1">
                {{ $t("products.isAttestationProduct") }}
              </p>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('products.col2')" width="120">
        <template slot-scope="scope">
          <p
            class="row-product-price"
            v-if="scope.row.MaxPrice == scope.row.MinPrice"
          >
            ${{ scope.row.MinPrice | formatPrice }}
          </p>
          <p class="row-product-price" v-else>
            ${{ scope.row.MinPrice | formatPrice }}~${{
              scope.row.MaxPrice | formatPrice
            }}
          </p>
        </template>
      </el-table-column>
      <el-table-column :label="$t('products.col3')" width="120">
        <template slot-scope="scope">
          <p class="row-product-sales">{{ scope.row.Sales }}</p>
        </template>
      </el-table-column>
      <el-table-column :label="$t('products.col4')" width="200">
        <template slot-scope="scope">
          <div class="row-product-create-time">
            <p class="date">{{ scope.row.CreateTimeTS | formatDate }}</p>
            <p class="state">
              {{
                scope.row.Status === 1
                  ? $t("products.onSale")
                  : $t("products.warehouse")
              }}
            </p>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('products.col7')" width="200">
        <template slot-scope="scope">
          <div class="row-product-inventory">
            <p class="number">{{ scope.row.TotalInventory }}</p>
            <p
              class="state"
              v-if="scope.row.ProductState == 2 || scope.row.ProductState == 3"
            >
              {{
                scope.row.ProductState === 2
                  ? $t("products.inventoryState1")
                  : $t("products.inventoryState2")
              }}
            </p>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('products.col5')" width="200">
        <template slot-scope="scope">
          <div class="row-product-create-time">
            <p class="date">{{ scope.row.Remark }}</p>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('products.col6')"
        class-name="column-action"
        align="center"
        width="300"
      >
        <template slot-scope="scope">
          <el-button-group>
            <el-button
              size="mini"
              type="primary"
              @click="handleEditProduct(scope.row)"
            >
              {{ $t("products.edit") }}
            </el-button>
            <el-button
              size="mini"
              type="warning"
              @click="handleToggleProductState(scope.row)"
            >
              {{ $t("products.now")
              }}{{
                scope.row.Status === 0
                  ? $t("products.state1")
                  : $t("products.state2")
              }}
            </el-button>
            <el-button
              size="mini"
              type="danger"
              v-show="scope.row.Status === 0"
              @click="handleDeleteProduct(scope.row)"
            >
              {{ $t("products.delete") }}
            </el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>

    <!-- 页码 -->
    <el-pagination
      class="pagination"
      :current-page="page"
      :page-sizes="[1, 5, 10, 15, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="count"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
export default {
  name: "Products",
  data() {
    return {
      state: this.$route.query.state === 0 ? 0 : 1, // 上架 => 1; 下架 => 0;
      page: 1,
      pageSize: 20,
      count: 0,
      lastPage: 0,
      contents: [],
    };
  },
  watch: {
    $route(to, from) {
      to.path === "/supplier/products" &&
        this.handleStateSwitch(this.$route.query.state === 0 ? 0 : 1);
    },
  },
  created() {
    this.request(this.state, this.page);
  },
  filters: {
    formatPrice(val) {
      var str = val.toFixed(2) + "";
      var intSum = str
        .substring(0, str.indexOf("."))
        .replace(/\B(?=(?:\d{3})+$)/g, ","); // 取到整数部分
      var dot = str.substring(str.length, str.indexOf(".")); // 取到小数部分搜索
      var ret = intSum + dot;
      return ret;
    },
    formatDate(val) {
      const date = new Date(val);
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      const hour = date.getHours().toString().padStart(2, "0");
      const min = date.getMinutes().toString().padStart(2, "0");
      const sec = date.getSeconds().toString().padStart(2, "0");
      return `${date.getFullYear()}-${month}-${day} ${hour}:${min}:${sec}`;
    },
  },
  methods: {
    request(state, page) {
      const param = {
        ScreenValues: state,
        PageIndex: page,
        PageSize: this.pageSize,
      };
      this.$api.product
        .loadProductsByPage(param)
        .then((res) => {
          this.state = state;
          this.page = res.meta.page;
          this.count = res.meta.total;
          this.lastPage = res.meta.lastPage;
          this.contents = res.data.map((item) => {
            item.imageUrl = this.$api.formatImageUrl(
              item.ProductPhoto.split("|")[0]
            );
            return item;
          });
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    handleStateSwitch(state) {
      if (this.state === state) return;
      this.request(state, 1);
    },
    // handleNextPage() {
    //   this.request(this.state, this.page + 1);
    // },
    // handlePreviousPage() {
    //   this.request(this.state, this.page - 1);
    // },
    handleSizeChange(val) {
      this.pageSize = val;
      this.request(this.state, this.page);
    },
    handleCurrentChange(val) {
      this.page = val;
      this.request(this.state, this.page);
    },
    handleAddProduct() {
      this.$router.push({
        name: "productClasses",
      });
    },
    handleDeleteProducts() {
      const selectedProducts = this.$refs.table.selection;
      if (selectedProducts.length <= 0) {
        this.$message({
          type: "warning",
          message: this.$t("products.deleteText"),
        });
        return;
      }

      const ListProductNumber = selectedProducts
        .map((p) => p.ProductNumber)
        .join("|");
      this.$api.product
        .deleteListProduct({ ListProductNumber })
        .then((_) => {
          this.request(this.state, 1);
        })
        .catch((err) => {
          this.message.error(err.message);
        });
    },
    handleDeleteProduct(product) {
      this.$api.product
        .deleteProduct({
          ProductNumber: product.ProductNumber,
        })
        .then((_) => {
          this.$alert(
            this.$t("products.deleteSuccess"),
            this.$t("products.tips"),
            {
              confirmButtonText: this.$t("products.confirm"),
              callback: (_) => {
                this.request(this.state, this.page);
              },
            }
          );
        })
        .catch((err) => {
          this.message.error(err.message);
        });
    },
    handleChangeProductsState(state) {
      const selectedProducts = this.$refs.table.selection;
      if (selectedProducts.length <= 0) {
        const stateStr =
          state === 1 ? this.$t("products.state1") : this.$t("products.state2");
        this.$message({
          type: "warning",
          message: this.$t("products.selectText", {
            string: stateStr,
          }),
        });
      }

      const param = {
        ListProductNumber: selectedProducts
          .map((p) => p.ProductNumber)
          .join("|"),
        Status: state,
      };
      this.$api.product
        .editListProductStatus(param)
        .then((_) => {
          this.request(this.state, 1);
        })
        .catch((err) => {
          this.message.error(err.message);
        });
    },
    handleToggleProductState(product) {
      const param = {
        ProductNumber: product.ProductNumber,
        Status: product.Status === 0 ? 1 : 0,
      };
      this.$api.product
        .editProductStatus(param)
        .then((_) => {
          const currentStateStr =
            product.Status === 0
              ? this.$t("products.state1")
              : this.$t("products.state2");
          this.$alert(
            `${currentStateStr}` + this.$t("products.success"),
            this.$t("products.tips"),
            {
              confirmButtonText: this.$t("products.confirm"),
              callback: (_) => {
                this.request(this.state, this.page);
              },
            }
          );
        })
        .catch((err) => {
          this.message.error(err.message);
        });
    },
    handleEditProduct(product) {
      this.$router.push({
        path: "productEdit",
        query: { number: product.ProductNumber },
      });
    },
  },
};
</script>

<style lang="scss" scoped>

.products {
  .row-product-name {
    display: flex;

    .image {
      width: 66px;
      height: 66px;
      flex-shrink: 0;
    }

    .content {
      margin-left: 20px;
      font-size: 12px;
      flex: 1;
      position: relative;
      p {
        margin: 0;
      }
      .title {
        color: #333;
        width: 7rem;
      }
      .labelimg {
        position: absolute;
        top: 0;
        left: 8rem;
      }

      .id {
        margin-top: 5px;
        color: #999;
      }
      .discount {
        display: inline-block;
        margin-left: 5px;
        margin-top: 5px;
        color: red;
      }
      .brand {
        display: inline-block;
        margin-left: 5px;
        margin-top: 5px;
        color: #e6a23c;
      }
      .att {
        display: inline-block;
        margin-left: 5px;
        margin-top: 5px;
        color: #22b196;
      }
    }
  }
  .row-product-price {
    margin: 0;
    font-size: 12px;
    color: #ff5852;
  }
  .row-product-sales {
    @extend .row-product-price;
    color: #333;
  }

  .row-product-create-time {
    font-size: 12px;

    p {
      margin: 0;
    }

    .date {
      color: #333;
    }

    .state {
      margin-top: 2px;
      color: #22b196;
    }
  }

  .row-product-inventory {
    font-size: 12px;

    p {
      margin: 0;
    }

    .number {
      color: #333;
    }

    .state {
      margin-top: 2px;
      color: red;
    }
  }

  .el-pagination {
    margin-top: 2%;
    margin-bottom: 2%;
    text-align: right;
  }
}
</style>
